export default {
    tabbar: {
        home: '首頁',
        trading: '交易',
        invest: '投資',
        share: '分享',
        mine: '我的'
    },
    common: {
        deposit: '存款',
        withdrawal: '提款',
        share: '分享',
        team: '團隊',
        task: '任務',
        addr: '地址',
        logout: '登出',
        wallet: '錢包',
        account: '賬戶',
        promotion: '推廣',
        details: '詳情',
        dailyRevenue: '每日收益',
        dailyRevenueList: '每日收益列表',
        aboutUs: '關於我們',
        globalPartners: '全球合作伙伴',
        totalBalance: '總餘額',
        profitList: '理財收益列表',
        notification: '通知',
        previous: '前一條',
        close: '關閉',
        next: '下一條',
        investWallet: '投資錢包',
        financialWallet: '理財錢包',
        recharge: '充值',
        copySucceeded: '複製成功',
        copyFailed: '複製失敗',
        promotionWallet: '推廣錢包',
        registerRewardWallet: '註冊獎勵錢包',
        toAddress: '收款的TRON錢包地址（T開頭）',
        verifyYourPassword: '驗證你的密碼',
        serviceFee: '礦工費',
        confirm: '確認',
        submitted: '已提交',
        date: '日期',
        amount: '金額',
        accountAvailableBalance: '賬戶可用餘額',
        securityPassword: '安全密碼',
        withdrawalPrincipal: '提取本金',
        withdrawalProfit: '提取利潤',
        profitRate: '利率',
        notificationAndFAQ: '常見問題&通知',
        FAQ: '常見問題',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:項目特色/介绍',
                content: `R:
1.作為業界首創且經過驗證審計的投資代碼，我們的解決方案旨在證明智能合約是投資的未來。 它的壽命和穩定性最終將顛覆加密產業以及人們對投資和交易的看法。 常規代幣產業面臨許多挑戰，包括代幣詐騙、地毯、市場波動、不誠實的開發人員竊取用戶資金以及缺乏流動性。

2.我們擁有的可靠性代碼是基於解決方案的結構， 我們解決方案不會以任何方式受到加密行業中出現的這些和許多其他挑戰的影響。 我們的平台不需要市場流動性。 因此，您的投資和預期收入是安全的，因為我們不依賴產業的變化。 相反，我們建立了一個基於新用戶吸引力但在智能合約上運行的解決方案！ 我們的程式碼和結構是安全的，並且有保證的壽命和透明度。 因此，我們有一個非常有吸引力和強大的推薦計劃，為每個推廣者/用戶提供詳細和透明的統計數據。 發起人的收入以及其他用戶的收入都會即時添加到個人資料中，與其他 DeFi 投資解決方案不同，人們可以隨時立即提取資金。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:我們的優勢在哪裡？',
                content: `R:我們的系統由 Haze 安全團隊審核，擁有獨立 Smart  Contract稽核員
1.安全又可靠：無需轉幣，USDT存入自己錢包0風險
2.專業穩定性：專業團隊，全年穩定運行
3.進入門檻低：分享節點挖礦收益
4.USD ETHW AI Strategy-C Mining Pool：無需轉移貨幣，收入穩定
5.我们致力於打造全球最大的整合DeFi平台 DEX, IMO, and DAO`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:我該如何參與？',
                content: `R:
1.錢包上鍊，錢包台附Dapp瀏覽器
2.將TRC20連接USDT並存入您的錢包
3.透過錢包瀏覽器進入宮網
4.您的錢包必須有30個以上trx作為礦工費才能參與本項目
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:參與挖礦需要多久時間？',
                content: `R:時間無法計算。 一般情況下4小時內即可完成。 若遇到其他不確定原因，時間可能會延長。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:為什麼我們需要支付礦工費才能兌現利潤？',
                content: `R:因為在這個參與挖礦的過程中,客戶只算名字,產生的礦工費已經由礦工統一支付了。 產生的收益實際上是在合約池中,只有支付礦工費才能換取收益。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:如何提取利潤？',
                content: `R:獲得USDT後，你的錢包裡必須有少量的TRX作為交易費用。 您只需支付一次，USDT兌換將在一個法定工作天內完成。 當你發起提現後， USDT提現會自動發送到您加入節點的錢包位址，不支援其他位址。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:什麼是Defi流動性挖礦？',
                content: `R:流動性挖礦是Defi去中心化金融的一種。 它不需要購買顯示卡、貢獻算力、支付昂貴的電費,而是透過提供資金和流動性來獲得收入。 尤其是近期,幣價波動較大。 對於一些堅定的持幣者來說，流動性挖礦是一種無需交易即可獲得收入並累積更多加密貨幣的方式。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:它是如何運作的？',
                content: `R:我們的解決方案是一種電腦化交易協議，可自動執行兩方之間的合約條款。 與通用合約類似，我們平台上的兩個使用者都必須在交易時定義參與規則和條款。 一旦達成協議並啟動智慧合約，它就會按照設計運行，對預定條件進行更改的機會為零。 用戶在區塊鏈節點的礦池中發起活動，合約上必須有可用餘額。 其餘用戶將其交給合約來執行，不再需要長時間等待來檢查何時出售或購買。 因此，根據合約條款，保證您的投資價值永不下降；相反，它為我們的用戶帶來 100% 的利潤。`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: '提款金額必須大於消耗的礦工費',
        supportTips: '親愛的用戶您好：我們為您設置了專屬礦池助手服務，您可以寫信給我們進行諮詢，投訴，建議等等，我們將在24小時內進行回復和處理！',
        tips: '提示',
        Withdrawals_prohibited: '當前未滿足提取條件，請先完成任務。'
    },
    homePage: {
        theCommonProblem: '常見問題',
        latestAnnouncement: '最新公告',
        block5title: '加入成爲TRON百萬富翁',
        block5desc: '使用雲挖礦和Defi技術確保所有用戶獲得最高的USDT收入。',
        block6title: '平臺數據展示',
        accumulatedProfit: '累計收益',
        membership: '會員',
        block7title: '我們正處於最佳狀態',
        block7desc: 'hako是一家在新加坡註冊的公司，許可證號：PS20200556。 我們是在波場智能鏈 (TRON) 網路上運作的加密貨幣領域唯一經過審計和驗證的智能合約投資網站。hako雲挖礦為比特幣USDT和其他加密貨幣提供了一種潜在的經濟高效的挖掘管道。 同時，定量交易和DeFi科技都將讓你輕鬆地以少量資金參與區塊鏈交易，並獲得保險等穩定收入。',
        tzl: '投資了',
        zl: '賺取了'
    },
    investPage: {
        productList: '產品列表',
        investedList: '已投資列表',
        dailyRate: '日利率',
        cycle: '週期',
        day: '天',
        productDetails: '產品詳細信息'
    },
    tradingPage: {
        miningWorking: '雲挖礦正在工作',
        tradingProfit: '交易收益',
        settlementRule: '24小時結算',
        viewAll: '查看全部',
        quantifyingTransactionRevenue: '量化交易收入',
        receive: '領取',
        received: '已領取',
        rule: '挖礦規則',
        rules: '如果你想讓“雲挖礦”開始工作並每日爲你賺取收益，請在“理財錢包”中激活。當你的錢包的USDT餘額滿足一定條件時，將每日獲得一筆收益，產生的收益將爲你保留30 天，請及時點擊領取。根據下列表格，計算你的每日收益百分比：',
        profit: '收益',
        miningNotWorking: '雲挖礦沒有工作，請激活它',
        balance: '餘額'
    },
    sharePage: {
        text1: '邀請你的聯繫人',
        text2: '或朋友並獲得獎勵',
        text3: '推薦並獲得獎勵',
        text4: '分享你的推薦鏈接，開始賺錢',
        copyLink: '複製鏈接'
    },
    minePage: {
        trxDepositInvestment: 'USDT投資存款',
        trxDepositFinancial: 'USDT理財存款',
        tips: '存入任意數量的USDT以激活賬戶並開通提款功能',
        appServices: '應用服務'
    },
    depositPage: {
        text1: '投資分爲兩種模式',
        text2: '1:充值到投資錢包中，你可以按照不同的週期獲得收益，到期時返還本金和收益',
        text3: '2:在理財錢包中激活“云挖矿”功能，每天按新加坡時區（12點後）獲得收入',
        text4: '注釋:',
        text5: '投資前，請根據您的投資需求選擇投資帳戶或理財帳戶進行投資。 請務必等待帳戶充值。 這是一個非常關鍵的問題。'
    },
    rechargePage: {
        trxAddress: 'TRC20-USDT 地址',
        copyAddress: '複製地址',
        tips1: '請不要為其他非 USDT 資產充值。 充值後約5~10分鐘進行記錄。',
        tips2: '如果長時間未送達，請重繪此頁面。 最低5 USDT投資。',
        rechargeCompleted: '充值完成',
        inactivated: '未激活',
        activated: '已激活',
        tips3: '無需重複點擊。請求發送後約5~10分鐘雲挖礦開始工作。',
        tips4: '如果長時間未激活，請重新點擊激活按鈕。',
        ActivateCloudMining: '激活雲挖礦'
    },
    withdrawalPage: {
        text1: '基本帳戶餘額（USDT）',
        text2: '提款將在24小時內收到',
        dailyWithdrawalLimit: '每日提款限額',
        unlimit: '無限制'
    },
    teamPage: {
        intro: '你直接邀請和間接邀請的用戶可以為你賺取分紅收益。 假設你邀請了A用戶，A用戶獲得的理財收益將按照百分比發送獎勵到你的錢包，如果A用戶邀請了B用戶，B又邀請了C，你可以同時獲得A（{lev2rate}%）、B（{lev3rate}%）、C（{lev4rate}%）用戶收益的百分比獎勵！',
        level: '層級',
        lev2: '二級',
        lev3: '三級',
        lev4: '四級',
        quantity: '數量',
        rewards: '獎勵'
    },
    productDetailsPage: {
        startingAmount: '起始金額',
        maxInvestmentAmount: '最大投資額',
        dailyInterestRate: '日利率',
        investableQuantity: '可投資數量',
        investmentAmount: '投資額',
        participateInInvestment: '參與投資'
    },
    investedListPage: {
        investmentTime: '投資時間',
        settlementTime: '結算時間',
        settlementAmount: '結算金額'
    },
    loginPage: {
        MobileNumber: '手機號碼',
        LoginPassword: '登錄密碼',
        SignIn: '登錄',
        SignUp: '註冊',
        rememberThePassword: '記住密碼',
        inviteCode: '邀請碼',
        captcha: '驗證碼',
        EncryptedRegistration: '加密註冊',
        desc: '密碼以分散的管道存儲，遺失後無法檢索。 請記住你的密碼。 ',
        registerSuccess: '已成功創建賬戶'
    },
    taskPage: {
        desc: '你邀請註冊的下級會員的每一筆有效充值金額都將按照一定的比例轉換爲您的提款額度（推廣獎勵賬戶）',
        rwconvertRate: '轉換比例',
        totalLimit: '累計額度',
        availableLimit: '可用額度',
        contactService: '聯繫客服'
    },
    Please_unlock_your_wallet: '請解鎖你的錢包',
    Please_open_the_website_in_the_Dapp_browser: '請在Dapp瀏覽器中打開網站'
}
